export default {
  translation: {
    lng: 'English',
    name: 'Name',
    email: 'Email',
    mobile: 'Mobile',
    password: 'Password',
    confirm_password: 'Confirm Password',
    are_you_truck_owner: 'Are you a truck owner?',
    yes: 'Yes',
    no: 'No',
    login: 'Login',
    sign_in: 'Sign-in',
    enter_login_credential: 'Enter your credentials to login',
    register: 'Register',
    enter_registration_credential: 'Enter your info to register',
    forgot_pass: 'Forgot password?',
    back_to_login: 'Back to login',
    enter_pin: 'Enter the pin you received.',
    please: 'Please',
    verify: 'Verify',
    send: 'Send',
    again: 'Again',
    send_again: 'Send Again',
    no_code_received: 'Did\'t receive any code?',
    expense: 'Expense',
  }
}
